// NodeSummary.jsx

import React, { useState } from 'react';

// Context
import { useCurrentLanguage } from 'context/LanguageContext';
import { useNodeTypes } from 'context/NodeTypesContext';
import { useTheme } from 'context/ThemeContext';

// Utilities
import { PhotoShape } from 'utilities/Enums';

// CSS
import './NodeSummary.css';

// Icons
import Icon from 'svg/Icon';

// Components
import NodeThumb from 'components/nodethumb/NodeThumb';

/**
 * NodeSummary
 *
 * Displays a single node in list (inbox) format.
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeSummary = ({ node, onClick }) => {

  // ----- CONTEXT ----- //

  // Theme Context

  const { theme } = useTheme();

  // ----- STATE ----- //

  const [hovered, setHovered] = useState(false);

  // ----- CONTEXT ----- //

  // Node Types Context

  const { getLabel } = useNodeTypes();

  // Language Context
  const language = useCurrentLanguage();

  const nodeTypeLabel = getLabel(node?.type, language);

  const title = node.title || nodeTypeLabel || "Untitled";

  if (!node) return null;

  // ----- RENDER ----- //

  return (
    <div
      className="node-summary-container"
      style={{
        backgroundColor: hovered ? theme.backgroundHover : undefined,
      }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

      {/* LEFT */}
      <div className="node-summary-left">
        <NodeThumb
          node={node}
          width="32px"
          height="32px"
          shape={PhotoShape.SQUARE}
        />
      </div>

      {/* CENTER */}
      <div className="node-summary-center">

        {/* CENTER TOP */}
        <div className="node-summary-center-top">

          {/* TITLE */}
          <div
            className="node-summary-title"
            style={{
              fontSize: '16px',
            }}
          >
            {title}
          </div>

        </div>

        {/* CENTER BOTTOM */}
        <div className="node-summary-center-bottom">

          {/* AUTHOR */}
          <div
            className="node-summary-author"
          >{node?.user.name}</div>

        </div>

      </div>

      {/* OPEN */}
      <div
        className="node-summary-open"
        title="Open"
      >
        <Icon
          iconKey="chevron_right"
          color={theme.foreground}
          width={16}
          height={16}
        />
      </div>

    </div>
  );
};

// Dev Tools
NodeSummary.displayName = 'NodeSummary';

export default NodeSummary;
